const plans = [
  {
    name: 'Plan A',
    duration: '1 Year',
    price: 1100,
    discount: ''
  },
  {
    name: 'Plan B',
    duration: '5 Years',
    price: 5100,
    discount: 500
  },
  {
    name: 'Plan C',
    duration: '10 Years',
    price: 10000,
    discount: 1000
  }
]

export default plans
